export default __webpack_public_path__ + "static/media/18.911383d2.jpg";